import { ref } from 'vue';
import { useStore } from 'vuex';

export function useEventSharing(eventId) {
  const store = useStore();

  const sharingEnabled = ref(false);
  const shareUrl = ref('');
  const copyingLink = ref(false);
  const saving = ref(false);

  const initFromEvent = eventData => {
    if (!eventData) return;
    sharingEnabled.value = eventData.public_sharing_enabled || false;
    shareUrl.value = eventData.public_share_url || '';
  };

  const toggleSharing = async newValue => {
    const eid =
      typeof eventId === 'function' ? eventId() : eventId.value || eventId;
    try {
      saving.value = true;
      if (newValue) {
        const response = await store.dispatch(
          'planningEvents/enableSharing',
          eid
        );
        shareUrl.value = response.share_url;
      } else {
        await store.dispatch('planningEvents/disableSharing', eid);
        shareUrl.value = '';
      }
      sharingEnabled.value = newValue;
    } catch {
      sharingEnabled.value = !newValue;
    } finally {
      saving.value = false;
    }
  };

  const copyShareLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl.value);
      copyingLink.value = true;
      setTimeout(() => {
        copyingLink.value = false;
      }, 2000);
    } catch (error) {
      console.error('Failed to copy:', error);
    }
  };

  const regenerateLink = async () => {
    const eid =
      typeof eventId === 'function' ? eventId() : eventId.value || eventId;
    try {
      saving.value = true;
      const response = await store.dispatch(
        'planningEvents/regenerateShareLink',
        eid
      );
      shareUrl.value = response.share_url;
    } finally {
      saving.value = false;
    }
  };

  return {
    sharingEnabled,
    shareUrl,
    copyingLink,
    saving,
    initFromEvent,
    toggleSharing,
    copyShareLink,
    regenerateLink,
  };
}
